














import Vue from "vue";

export default Vue.extend({
  props: {
    SuperPayPaymentData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {};
  },
  methods: {
    getData() {
      return {
        KNVSuperPayManager_UserDefault_Stored_MerchantId: this.SuperPayPaymentData.KNVSuperPayManager_UserDefault_Stored_MerchantId
      };
    }
  }
});
